/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function InheritedDimensionTagFromJSON(json) {
    return InheritedDimensionTagFromJSONTyped(json, false);
}
export function InheritedDimensionTagFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        dimensionTagId: json['dimensionTagId'],
        ancestorName: json['ancestorName'],
        ancestorId: json['ancestorId'],
        depth: json['depth'],
        order: json['order'],
        generated: json['generated'],
    };
}
export function InheritedDimensionTagToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        dimensionTagId: value.dimensionTagId,
        ancestorName: value.ancestorName,
        ancestorId: value.ancestorId,
        depth: value.depth,
        order: value.order,
        generated: value.generated,
    };
}
